/**
 * External dependencies
 */
import React from "react";

export default () => {
  return (
    <footer>
      <nav className="navbar navbar-default">
        <div className="container">
          <div
            className="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul className="nav navbar-nav">
              <li>
                <a href="/#">ADVERTISING</a>
              </li>
              <li>
                <a href="/#">JOBS</a>
              </li>
              <li>
                <a href="/#">PRESS</a>
              </li>
              <li>
                <a href="/#">HELP</a>
              </li>
              <li>
                <a href="/#">ABOUT US</a>
              </li>
              <li>
                <a href="/#">SITE MAP</a>
              </li>
              <li>
                <a href="/#">BLOG</a>
              </li>
            </ul>
            <ul className="nav navbar-nav navbar-right">
              <li>&copy;2018 INKREDIBLE RETAIL</li>
            </ul>
          </div>
        </div>
      </nav>
    </footer>
  );
};
